<template>
  <div class="nav flex">
    <p>当前位置：</p>
    <span @click="indexHandle()">首页</span>
    <span @click="navHandle(item)" v-for="(item, index) in navList" :key="index"><i>></i>{{ item.strName }}</span>
  </div>
</template>

<script>
export default {
  name: 'News',
  data() {
    return {}
  },
  props: {
    navList: {
      type: Array,
      default: () => []
    }
  },
  created() {

  },
  methods: {
    // 首页跳转
    indexHandle(){
      this.$router.push({ path:'/index', query: { strWebSiteId: this.$route.query.strWebSiteId } })
    },
    // 菜单跳转
    navHandle (item) {
      this.$router.push({ path:'/list', query: { strId: item.strId, strWebSiteId: this.$route.query.strWebSiteId } })
    }
  }
}
</script>

<style scoped lang="scss">
  .nav {
    background: url('../../assets/images/nav-bg.jpg') no-repeat center center;
    height: 40px;
    line-height: 40px;
    margin: 15px 0;
    padding: 0 0 0 20px;
    box-sizing: border-box;
    background-size: 100% 100%;
    color: #4a4a4a;
    font-size: 1em;
    span {
      color: #3273dc;
      cursor: pointer;
      font-size: 12px;
      margin: 0;
      i {
        font-style: normal;
        margin: 0 6px
      }
    }
  }
</style>